export const FETCH_USER_INTERACTIONS_SETTING_IN_PROGRESS = 'FETCH_USER_INTERACTIONS_SETTING_IN_PROGRESS';
export const FETCH_USER_INTERACTIONS_SETTING_SUCCESS = 'FETCH_USER_INTERACTIONS_SETTING_SUCCESS';
export const FETCH_USER_INTERACTIONS_SETTING_ERROR = 'FETCH_USER_INTERACTIONS_SETTING_ERROR';
export const UPDATE_XLIFF_CONTENT_SUCCESS = 'UPDATE_XLIFF_CONTENT_SUCCESS';
export const UPDATE_XLIFF_CONTENT_ERROR = 'UPDATE_XLIFF_CONTENT_ERROR';
export const CLEAR_USER_INTERACTION_SETTING = 'CLEAR_USER_INTERACTION_SETTING';
export const DELETE_INTERACTION_ERROR = 'DELETE_INTERACTION_ERROR';
export const DELETE_INTERACTION_SUCCESS = 'DELETE_INTERACTION_SUCCESS';